//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

export enum SUMMARY_TREND_VALUES {
  ENGAGEMENT_RATE = 'engagementRate',
  FOLLOWERS = 'followerCount',
  CHANGE_IN_FOLLOWERS = 'changeInFollowers',
  NEW_FOLLOWERS_DAY = 'followerCountDay',
  POSTS = 'photoCount',
  NEW_POSTS = 'newPosts',
  LIKES = 'likeCount',
  NEW_LIKES = 'newLikeCount',
  COMMENTS = 'commentCount',
  NEW_COMMENTS = 'newCommentCount',
  IMPRESSIONS = 'impressionCount',
  ACCOUNT_REACH = 'reach',
  ACCOUNT_REACH_DAY = 'reachDay',
  REVENUE = 'revenue',
  TRANSACTIONS = 'transactions',
  TRAFFIC = 'traffic',
}

export const SUMMARY_TREND_VALUE_LABELS = {
  [SUMMARY_TREND_VALUES.ENGAGEMENT_RATE]: 'Total Eng. Rate',
  [SUMMARY_TREND_VALUES.FOLLOWERS]: 'Followers',
  [SUMMARY_TREND_VALUES.CHANGE_IN_FOLLOWERS]: 'Change in Followers',
  [SUMMARY_TREND_VALUES.NEW_FOLLOWERS_DAY]: 'New Followers',
  [SUMMARY_TREND_VALUES.POSTS]: 'Posts',
  [SUMMARY_TREND_VALUES.NEW_POSTS]: 'New Posts',
  [SUMMARY_TREND_VALUES.LIKES]: 'Total Likes',
  [SUMMARY_TREND_VALUES.NEW_LIKES]: 'New Likes',
  [SUMMARY_TREND_VALUES.COMMENTS]: 'Total Comments',
  [SUMMARY_TREND_VALUES.NEW_COMMENTS]: 'New Comments',
  [SUMMARY_TREND_VALUES.IMPRESSIONS]: 'Impressions',
  [SUMMARY_TREND_VALUES.ACCOUNT_REACH]: 'Account Reach',
  [SUMMARY_TREND_VALUES.ACCOUNT_REACH_DAY]: 'Account Reach',
  [SUMMARY_TREND_VALUES.REVENUE]: 'Revenue',
  [SUMMARY_TREND_VALUES.TRANSACTIONS]: 'Transactions',
  [SUMMARY_TREND_VALUES.TRAFFIC]: 'Site Visits',
};
